import { FaArrowLeft, FaCalendarAlt, FaClock, FaMapMarkerAlt, FaCheck,FaFileCsv, FaFileExcel, FaFilePdf } from 'react-icons/fa';


const AttendanceModals = ({
  isEventSelectionOpen,
  events,
  onSelectEvent,
  onCloseEventSelection,
  onBackWhenNoEvents,
  isExportModalOpen,
  onCloseExportModal,
  onExport,
  scanPopup,
}) => (
  <>
    {isEventSelectionOpen && (
      <div className="attendance-modal-overlay">
        <div className="attendance-event-selection-modal">
          <h3 className="attendance-event-title">Select Event for Attendance</h3>
          <p className="attendance-event-description">
            Choose an event that is currently occurring:
          </p>

          {events.length > 0 ? (
            <div className="attendance-event-list">
              {events.map((event) => (
                <div
                  key={event.event_id || event.eventid || event.id}
                  className="attendance-event-item"
                  onClick={() => onSelectEvent(event)}
                >
                  <div className="attendance-event-info">
                    <h4 className="attendance-event-info-title">
                      {event.event_name || event.name || event.title || 'Unnamed Event'}
                    </h4>
                    <div className="attendance-event-details">
                      <span className="attendance-event-detail-row">
                        <FaCalendarAlt />
                        {new Date(
                          event.event_date || event.startdate || event.startDate || event.start_date
                        ).toLocaleDateString()}
                      </span>
                      <span className="attendance-event-detail-row">
                        <FaClock />
                        {new Date(
                          event.event_date || event.startdate || event.startDate || event.start_date
                        ).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                      </span>
                      <span className="attendance-event-detail-row">
                        <FaMapMarkerAlt />
                        {event.venue || event.location || 'N/A'}
                      </span>
                    </div>
                  </div>
                  <div className="attendance-event-select-arrow">
                    <FaArrowLeft />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="attendance-no-events">
              <div className="attendance-no-events-icon">📅</div>
              <p className="attendance-no-events-text">
                No events are currently occurring
              </p>
              <button
                className="attendance-no-events-back-button"
                onClick={onBackWhenNoEvents}
              >
                <FaArrowLeft /> Back
              </button>
            </div>
          )}
        </div>
      </div>
    )}

    {isExportModalOpen && (
      <div className="modal-overlay">
        <div className="modal-content">
          <h3>Export Scanned Tickets</h3>
          <p>Select format to export the scanned tickets data:</p>
          <div className="export-options">
            <button className="export-option" onClick={() => onExport('csv')}>
              <FaFileCsv /> CSV
            </button>
            <button className="export-option" onClick={() => onExport('excel')}>
              <FaFileExcel /> Excel
            </button>
            <button className="export-option" onClick={() => onExport('pdf')}>
              <FaFilePdf /> PDF
            </button>
          </div>
          <button className="close-button" onClick={onCloseExportModal}>
            Close
          </button>
        </div>
      </div>
    )}

    {scanPopup.show && (
      <div className="scan-popup-overlay">
        <div className="scan-popup">
          <div className="scan-popup-icon success">
            <FaCheck />
          </div>
          <div className="scan-popup-content">
            <h3>Scan Successful!</h3>
            <p>
              Code: <strong>{scanPopup.code}</strong>
            </p>
          </div>
        </div>
      </div>
    )}
  </>
);

export default AttendanceModals;
